export default __webpack_public_path__ + "static/5-d3e3daefc9abfb32114f56e5206b4a30.jpeg";